import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { IntegrationNavigator } from './integrationNavigator';
import { IntegrationHub } from './hub';
import DealComplexity from './dealComplexity';
import GdPcps from './gdPcps';
import { connect, useSelector } from 'react-redux';
import actions from '@flux/action';
import ProjectCard from './projectTile';
import { USER_PERMISSION_MODEL } from '@model/userPermission';
import LifeCycleModule from './lifeCycle/lifeCycleModuleWithCommentAnchor';
import SectionSorter from './sectionSorter';
import { API } from '@service';
import { INTEGRATION_TYPES } from '@model/projectDetails';
import WidgetEditTableDemo from './widgetEditTableDemo';
import { SectionChart } from '@components';
import ExecutiveSummary from './executiveSummary/ExecutiveSummaryWrap';

// import '@style/modules/project/projectDetail.scss';
import '../../../styles/modules/project/projectDetail.scss';
import isEmpty from 'lodash/isEmpty';

import { setSessionStorage } from '@utils/windowUtil';

// import '../../../styles/components/card.scss';
// import '../../../styles/modules/insights/guideDrawer.scss';
// import '../../../styles/modules/insights/guideDrawerContent.scss';

const SECTIONS = {
  NAVIGATOR: 'navigator',
  LIFECYCLE: 'lifecycle',
  LIFECYCLE_DIVESTITURE: 'lifecycleDivestitures',
  COMPLEXITY: 'complexity',
  EXECUTIVE_SUMMARY: 'executiveSummary',
  HUB: 'hub',
};

// const ProjectScrollInfoKey = 'projectScrollInfo';

const genExpandedClassName = (b) => (b ? ' expanded' : '');

const ExpandBtnRight = ({ handleToggleExpand, isExpand = false }) => (
  <div
    className={`expand-btn-right${genExpandedClassName(isExpand)}`}
    onClick={handleToggleExpand}
  >
    <span className="text"> Guiding Principles</span>
    <span
      className={`appkiticon icon-${isExpand ? 'up' : 'down'}-chevron-fill`}
    />
  </div>
);

// const restoreProjectHomeScroll = (projectId) => {
//   let scrollInfo = window.SessionStorage.getItem(ProjectScrollInfoKey);
//   scrollInfo =
//     typeof scrollInfo === 'string' ? JSON.parse(scrollInfo) : scrollInfo;
//   if (
//     scrollInfo &&
//     scrollInfo?.projectId === projectId &&
//     scrollInfo?.scrollY > 0
//   ) {
//     setTimeout(() => {
//       window.scrollTo({
//         left: 0,
//         top: scrollInfo?.scrollY,
//         // behavior: 'smooth',
//       });
//       window.SessionStorage.removeItem(ProjectScrollInfoKey);
//     }, 100);
//   }
// }

const guidingPrincipleVisible = (permissionCodes = [], instanceType) =>
  ((instanceType === 'Integration' || instanceType === 'Customize') &&
    permissionCodes.includes(
      USER_PERMISSION_MODEL.INSIGHT.guidingPrinciples,
    )) ||
  (instanceType === 'Divestiture' &&
    permissionCodes.includes(
      USER_PERMISSION_MODEL.INSIGHT['guidingPrinciples-divestitures'],
    ));

function ProjectDetail(props) {
  const {
    match: {
      params: { id },
    },
    history,
    location,
    projectInfo,
    integrationModuleData,
    tabs,
    // permission,
    // internalPermission,
    // userInfo: { role },
    userInfo,
    complexityData,
    lifecycleData,
    currentTab,
    groupInfo,
    changeCurrentTab,
    getAccessibleModules,
    fetchAcceleratingTransition,
    saveProjectStatusToStore,
    cachedProjectStatus,
    changeLoading,
    accessibleModules,
    accepted,
    projectCompanyInfo,
    displayMode,
    permissionLoading,
    permissionBundleProjectId,
  } = props;
  const {
    singleCompanyInstance,
    instanceType,
    instanceName,
    instanceIsDeleted,
  } = useSelector(({ common }) => common.projectCompanyInfo);
  const { preventRefresh } = location.state || {};

  // useEffect(() => {
  //   if (sectionChartRef.current) {
  //   }

  // }, [sectionChartRef]);
  const {
    changeCurrentId,
    fetchData,
    // getUserPermission,
    getProjectBasicInfo,
    getCustomizedModules,
  } = props;

  const [isGdPrcpExpand, setIsGdPrcpExpand] = useState(false);
  const [collapseId, setCollapseId] = useState('');
  const [restData, saveRestData] = useState('');
  const [modalLoading, setModalLoading] = useState(false);
  const [sectionOrder, setSectionOrder] = useState([]);
  const [sectionSorterRefresher, setSectionSorterRefresher] = useState();
  const refresh = () => setSectionSorterRefresher((b) => !b);
  const [isSettingModalShow, toggleSettingModalShow] = useState(false);
  const [activeSectionInModal, setActiveSectionInModal] = useState(null);

  const renderComplexity = ({ ...rest }) =>
    singleCompanyInstance !== 'Divestiture' && (
      <DealComplexity
        complexityData={complexityData}
        titleName={rest.titleName}
      />
    );

  const renderNavigator = ({ identifier, titleName }) => (
    <IntegrationNavigator
      currentTab={currentTab}
      tabs={tabs}
      onTabChange={handleTabChange}
      history={props.history}
      list={(integrationModuleData || {})[currentTab] || []}
      name={titleName}
      identifier={identifier}
      handleRefresh={() => fetchAcceleratingTransition(id)}
      groupInfo={groupInfo}
      displayMode={displayMode}
    />
  );

  const renderLifecycle = ({ titleName, identifier, refresher }) => {
    // const lifeCycleData =
    //   identifier === 'lifecycleDivestitures' ? divestiture : integration;
    const lifeCycleType =
      identifier === 'lifecycleDivestitures' ? 'Divestiture' : 'Integration';
    const typeId = projectCompanyInfo.companyInstance;
    // const lifeCycleTitle = lifeCycleData.title;
    return isEmpty(lifecycleData) ? null : (
      <LifeCycleModule
        titleName={titleName}
        data={lifecycleData}
        projectId={id}
        type={lifeCycleType}
        typeId={typeId}
        identifier={identifier}
        projectStatusRefresher={refresher}
      />
    );
  };

  const renderExecutiveSummary = ({ identifier, titleName }) => (
    <ExecutiveSummary
      titleName={titleName}
      projectId={id}
      identifier={identifier}
    />
  );

  const toggleEditModalBySection = (section) => () => {
    setActiveSectionInModal(section);
    toggleSettingModalShow(true);
    setSectionSorterRefresher(!sectionSorterRefresher);
  };

  const renderHub = ({ section = {}, ...rest }) => {
    return (
      <IntegrationHub
        section={section}
        {...rest}
        id={id}
        toggleEditModal={toggleEditModalBySection(section)}
      />
    );
  };
  const SECTION_COMP_MAP = {
    [SECTIONS.COMPLEXITY]: renderComplexity,
    [SECTIONS.NAVIGATOR]: renderNavigator,
    [SECTIONS.LIFECYCLE]: renderLifecycle,
    [SECTIONS.LIFECYCLE_DIVESTITURE]: renderLifecycle,
    [SECTIONS.EXECUTIVE_SUMMARY]: renderExecutiveSummary,
    [SECTIONS.HUB]: renderHub,
  };

  useEffect(() => {
    // Terms are fetched once after login in AppContainer; wait until we have a value
    if (typeof accepted === 'undefined') {
      return;
    }
    if (!accepted) {
      return;
    }
    // Avoid duplicating permission APIs while AppContainer.fetchPermissionData runs
    if (permissionLoading) {
      return;
    }
    const permissionAlreadyForProject =
      permissionBundleProjectId != null &&
      String(permissionBundleProjectId) === String(id);

    const projectDataAlreadyLoaded =
      permissionAlreadyForProject &&
      integrationModuleData &&
      projectInfo?.projectId &&
      String(projectInfo.projectId) === String(id);

    if (projectDataAlreadyLoaded) {
      setSessionStorage('currentId', id);
      return;
    }

    if (preventRefresh && cachedProjectStatus) {
      setSessionStorage('currentId', id);
      return;
    }

    let cancelled = false;

    (async () => {
      changeLoading(true);
      try {
        if (permissionAlreadyForProject) {
          changeCurrentId(id);
          await fetchData(id, { skipGlobalLoading: true });
        } else {
          await getProjectBasicInfo(id);
          changeCurrentId(id);
          await fetchData(id, { skipGlobalLoading: true });
          await getCustomizedModules(id, { skipGlobalLoading: true });
          await getAccessibleModules(id);
        }
      } finally {
        if (!cancelled) {
          changeLoading(false);
          setTimeout(() => {
            window.scrollTo({ top: 0 });
          }, 100);
        }
      }
    })();

    setSessionStorage('currentId', id);

    setTimeout(() => {
      history.replace({ ...location, state: {} });
    }, 0);

    const data = userInfo.isClient
      ? {
          email: userInfo.email,
        }
      : {
          guid: userInfo.guid,
        };

    API.accessRecord(id, data);

    return () => {
      cancelled = true;
      changeLoading(false);
    };
  }, [id, accepted, permissionLoading]);

  const changeOrderPropsValue = (sectionOrder, identifierV, prop, value) => {
    const orders = sectionOrder.map((order) => {
      if (order.identifier === identifierV) {
        return { ...order, [prop]: value };
      }
      return order;
    });
    return orders;
  };

  const handleProjectStatus = useCallback(
    (projectStatusData = {}) => {
      if (!projectStatusData) {
        return;
      }
      const { moduleOrderAndFlag, ...rest } = projectStatusData;
      if (id) {
        saveRestData(rest);
        setCollapseId(id);
        setSectionOrder(moduleOrderAndFlag);
        setModalLoading(false);

        saveProjectStatusToStore(
          Object.assign(projectStatusData, {
            integrationNavigatorName: (
              moduleOrderAndFlag?.find((e) => e.identifier === 'navigator') ||
              {}
            ).titleName,
          }),
        );
      }
    },
    [id, saveProjectStatusToStore],
  );

  const refetchProjectStatusData = async () => {
    setModalLoading(true);
    changeLoading(true);
    await API.getProjectStatus(id).then(handleProjectStatus);
    changeLoading(false);
  };

  const refreshProjectStatusData = () => {
    if (preventRefresh && cachedProjectStatus) {
      handleProjectStatus(cachedProjectStatus);
      return null;
    }
    refetchProjectStatusData();
    return null;
  };

  useEffect(() => {
    // Project status is rejected until terms are accepted; wait for the flag so
    // the T&C modal is not torn down by a failed request.
    if (accepted !== true) {
      return;
    }
    refreshProjectStatusData();
  }, [sectionSorterRefresher, id, accepted]);

  const saveLink = (section, link) => {
    const orders = changeOrderPropsValue(
      sectionOrder,
      section.identifier,
      'link',
      link,
    );
    setSectionOrder(orders);
    return saveStatus(orders);
  };

  useEffect(() => {
    const navigatorSection =
      (sectionOrder || []).find((e) => e.identifier === 'navigator') || {};

    const newProjectInfo = {
      ...cachedProjectStatus,
      integrationNavigatorName: navigatorSection.titleName,
      moduleOrderAndFlag: sectionOrder,
    };
    saveProjectStatusToStore(newProjectInfo);
  }, [sectionOrder]);

  const saveStatus = async (newOrder) => {
    const navigatorSection =
      (newOrder || []).find((e) => e.identifier === 'navigator') || {};
    const data = {
      projectStatusInfo: {
        ...restData,
        id: collapseId,
        moduleOrderAndFlag: newOrder || sectionOrder,
        integrationNavigatorName: navigatorSection.titleName,
      },
    };

    await API.dealComplexityCollapseSwitch(id, data);
    getAccessibleModules(id);
  };
  const handleTabChange = ({ currentTab: { id } }) => {
    changeCurrentTab(id);
  };

  // const toggleModuleExpand = (module) => {
  //   const orders = sectionOrder.map((order) => {
  //     if (order.identifier === module.identifier) {
  //       order.hideFlag = !order.hideFlag;
  //     }
  //     return order;
  //   });
  //   updateAccessibleModules(module);
  //   setSectionOrder(orders);
  //   saveStatus(orders);
  // };

  const onSortEnd = async (order) => {
    await saveStatus(order);
    setSectionOrder([...order]);
    refetchProjectStatusData();
  };

  const canViewGdPrcpls = guidingPrincipleVisible(
    accessibleModules?.moduleList,
    instanceType,
  );

  const customizeHome = (
    <SectionSorter
      setSectionOrder={onSortEnd}
      order={sectionOrder}
      refresh={sectionSorterRefresher}
      refresher={setSectionSorterRefresher}
      modalLoading={modalLoading}
      isModalShow={isSettingModalShow}
      toggleModalShow={toggleSettingModalShow}
      activeSection={activeSectionInModal}
      clearActiveSection={() => setActiveSectionInModal(null)}
    />
  );

  if (!integrationModuleData || !projectInfo) {
    return null;
  }

  return (
    <div className="project-detail page-wrapper">
      <ProjectCard
        data={{ ...projectInfo, instanceType, instanceName, instanceIsDeleted }}
        customizeHomeBtn={customizeHome}
        userInfo={userInfo}
      />
      {/* <WidgetEditTableDemo projectInfo={projectInfo} /> */}
      {/* <SectionChart chartPattern="gantt" noDataFlag={false} /> */}
      {/* <SectionChart chartPattern="Org Chart" noDataFlag={true}/> */}
      {canViewGdPrcpls ? (
        <ExpandBtnRight
          isExpand={isGdPrcpExpand}
          handleToggleExpand={() => setIsGdPrcpExpand((v) => !v)}
        />
      ) : null}
      {canViewGdPrcpls ? (
        <div
          className={`expand-guiding-principle${genExpandedClassName(
            isGdPrcpExpand,
          )}`}
        >
          <GdPcps />
        </div>
      ) : null}

      {sectionOrder.map((section) => {
        const { isPowerBIModule, removeFlag } = section;
        if (
          !isPowerBIModule &&
          !removeFlag &&
          SECTION_COMP_MAP[section.identifier]
        ) {
          return SECTION_COMP_MAP[section.identifier](
            Object.assign({}, section, {
              refresher: refetchProjectStatusData,
            }),
          );
        } else if (!removeFlag && isPowerBIModule) {
          return SECTION_COMP_MAP.hub({
            section,
            id,
            saveLink,
            sectionOrder,
            changeOrderPropsValue,
            onSortEnd,
            refresh,
          });
        }
        return null;
      })}
    </div>
  );
}

const mapStateToProps = ({
  projects: {
    projectDetail,
    sectionsPermission,
    internalSectionsPermission,
    projectStatus,
    originAccessibleModules,
    permissionLoading,
    permissionBundleProjectId,
  },
  login,
  common,
}) => {
  const tabs = projectDetail.tabs || [];
  // .filter((tab) => tab.showable);

  let currentTab;

  if (
    Object.keys(projectDetail.integrationModuleData || {}).includes(
      projectDetail.currentTab,
    )
  ) {
    currentTab = projectDetail.currentTab;
  }

  return {
    projectInfo: projectDetail.projectInfo || {},
    integrationModuleData: projectDetail.integrationModuleData,
    groupInfo: projectDetail.groupInfo,
    // permission: sectionsPermission.insightPermission,
    tabs,
    // internalPermission: internalSectionsPermission.insightPermission,
    currentTab: currentTab || tabs[0]?.id || 'Home',
    userInfo: login.userInfo || {},
    complexityData: projectDetail.complexityData || {},
    lifecycleData: projectDetail.lifecycleData,
    // lifecycleData: {
    //   integration: projectDetail.lifecycleData?.lifecycleData_integration || {},
    //   divestiture: projectDetail.lifecycleData?.lifecycleData_divestiture || {},
    // },
    cachedProjectStatus: projectStatus,
    accessibleModules: originAccessibleModules,
    permissionLoading,
    permissionBundleProjectId,
    accepted: login.userInfo.accepted,
    projectCompanyInfo: common.projectCompanyInfo,
    displayMode:
      projectDetail.originIntegrationData?.displayMode === 'Tile'
        ? projectDetail.originIntegrationData.displayMode
        : 'List',
    // displayMode: 'Tile', //Tile list changes happen from here (RCA breakpoint)
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeCurrentId(id) {
    return dispatch(actions.changeCurrentId(id));
  },
  fetchData(id, options) {
    return dispatch(actions.fetchProjectDetails(id, options));
    // dispatch(actions.fetchTotalRevenue(id));
  },
  getProjectBasicInfo(id) {
    return dispatch(actions.getProjectInfo(id));
  },
  fetchAcceleratingTransition(id) {
    return dispatch(actions.fetchAcceleratingTransition(id));
  },
  // getUserPermission(id) {
  //   dispatch(actions.getUserPermission(id));
  // },
  changeCurrentTab(currentTab) {
    dispatch(actions.saveProjectDetail({ currentTab }));
  },
  changeModuleStatus(p) {
    dispatch(actions.saveModuleStatus(p));
  },
  getCustomizedModules(p, options) {
    return dispatch(actions.getCustomizedModules(p, options));
  },
  updateAccessibleModules(module) {
    dispatch(
      actions.updateAccessibleModules(
        Object.assign({}, module, { module: 'Project Home' }),
      ),
    );
  },
  getAccessibleModules(id) {
    return dispatch(actions.getAccessibleModules(id));
  },
  saveProjectStatusToStore(data) {
    dispatch(actions.saveProjectStatus(data));
  },
  changeLoading(flag) {
    dispatch(actions.changeLoading(flag));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ProjectDetail));
